import React from "react";
import styles from "./requestCompleteModal.module.scss";
import img from "../../assets/img/chara-selena-002.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  handler: () => void;
  type: string;
  chat_partner: string;
  ownerChatDenial: boolean;
  createRoomResult: boolean;
};
const RequestCompleteModalBody: React.FC<Props> = ({
  handler,
  type,
  chat_partner,
  ownerChatDenial,
  createRoomResult,
}) => {
  return (
    <div className={styles["requestCompleteModal"]}>
      <div className={styles["requestCompleteModal-text"]}>
        <FontAwesomeIcon icon={["fal", "check-circle"]} />
        <div>{`${type}完了`}</div>
        <p>
          {`${type}が完了しました。`}
          <br />
          これより運営が対応を進めます。
          <br />
          ご連絡までしばらくお待ちください。
        </p>
        <span>※内容によっては数日お時間をいただく可能性がございます。</span>
        <br />
        {!createRoomResult ? (
          <p
            className={`${styles["requestCompleteModal__chat"]} ${styles["denial"]}`}
          >
            チャットルームの作成に失敗しました。
            <br />
            運営よりルームを作成いたしますので、
            <br />
            １～２営業日お待ちください。
          </p>
        ) : ownerChatDenial ? (
          <p
            className={`${styles["requestCompleteModal__chat"]} ${styles["denial"]}`}
          >
            このユーザーとは現在チャットはできません。
            <br />
            やり取りはSELeCT運営を介して行えます。
          </p>
        ) : (
          <p className={styles["requestCompleteModal__chat"]}>
            {chat_partner}
            とチャットが利用できます。
            <br />
            マイページからご利用ください。
          </p>
        )}
      </div>
      <div className={styles["requestCompleteModal-img"]}>
        <img src={img} />
      </div>
      <div className={styles["requestCompleteModal-btn"]}>
        <button type="button" onClick={handler}>
          完了
        </button>
      </div>
    </div>
  );
};

export default RequestCompleteModalBody;
